export default __webpack_public_path__ + "static/media/dummy.141304c3.svg";